import React from "react";
import { node, oneOf, string } from "prop-types";
import { classes } from "../utils/classes";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";
import { fontSizePropTypes, sxClassName, sxProps, sxPropTypes } from "../props/sx";
import { utilityClassName, utilityProps, utilityPropTypes } from "../props/utility";

const UListItem = ({
	bulletColor,
	size,
	utility = { ...utilityProps },
	sx = { ...sxProps },
	spacing = { ...spacingProps },
	className = "",
	children,
	...props
}) => {
	return (
		<li
			className={classes(
				"li",
				size && `text-${size}`,
				bulletColor && `li--bullet-color-${bulletColor}`,
				...utilityClassName(utility),
				...sxClassName(sx),
				...spacingClassName(spacing),
				className,
			)}
			{...props}
		>
			{children}
		</li>
	);
};

UListItem.propTypes = {
	size: fontSizePropTypes,
	bulletColor: oneOf(["orange", "dotmatics-2", "dotmatics-7", "black--custom-1"]),
	className: string,
	children: node.isRequired,
	utility: utilityPropTypes,
	sx: sxPropTypes,
	spacing: spacingPropTypes,
};

const UList = ({ type = "default", spacing = { ...spacingProps }, className = "", children }) => {
	return (
		<ul className={classes("ul", `ul-${type}`, ...spacingClassName(spacing), className)}>
			{children}
		</ul>
	);
};

UList.propTypes = {
	type: oneOf(["default", "pros", "cons"]),
	className: string,
	children: node.isRequired,
	spacing: spacingPropTypes,
};

UList.Item = UListItem;

export default UList;
